import { classes, st } from './ricos-styles.st.css';
export const getCssOverrides = (isMobile, type) => {
    return Object.assign({}, (type === 'viewer'
        ? { text: st(classes.text, { isMobile }, classes.noBackground) }
        : {
            text: st(classes.editorText, { isMobile }, classes.noBackground),
            editor: st(classes.editorText, { isMobile }, classes.noBackground),
            wrapper: st(classes.placeholder, { isMobile }),
            mentionSuggestions: classes.mentionSuggestions,
        }));
};
//# sourceMappingURL=ricos-styles.js.map